import { API_URL } from "../config";
import { buildCheckoutAuthHeaders } from "./checkoutSession";

const PROFILE_CACHE_MS = 5000;
let currentProfileCache = null;
let currentProfileInflight = null;

export async function getCurrentUserProfile(options = {}) {
  const now = Date.now();
  if (!options.force && currentProfileCache && currentProfileCache.expiresAt > now) {
    return currentProfileCache.value;
  }
  if (!options.force && currentProfileInflight) {
    return currentProfileInflight;
  }

  currentProfileInflight = fetch(`${API_URL}/perfil`, {
    credentials: "include",
    headers: buildCheckoutAuthHeaders(),
  })
    .then(async (response) => {
      if (!response.ok) {
        return null;
      }
      return response.json();
    })
    .then((profile) => {
      if (profile) {
        currentProfileCache = {
          value: profile,
          expiresAt: Date.now() + PROFILE_CACHE_MS,
        };
      }
      return profile;
    })
    .finally(() => {
      currentProfileInflight = null;
    });

  return currentProfileInflight;
}

export function clearCurrentUserProfileCache() {
  currentProfileCache = null;
  currentProfileInflight = null;
}
